export default "__VITE_ASSET__DCrntqZY__"